<form novalidate #motorsListingDetailsPackageSectionForm="ngForm">
  <div *ngIf="packageList.length > 0">
    <tg-row *ngIf="draftLoaded$ | async">
      <tg-col>
        <tg-row>
          <tg-col sm="12">
            <h1 class="motors-listing-details-package-section__title">
              Choose your package
            </h1>
          </tg-col>
        </tg-row>

        <tg-row>
          <tg-col lg="10" sm="12">
            <tg-row class="motors-listing-details-package-section__cardRow" flexContents>
              <tg-col md="4" sm="12" *ngFor="let package of packageList" [motorsCardSelection]="!package.isDisabled">
                <tg-card class="motors-listing-details-package-section__card" bordered
                  [ngClass]="{selectedCard: package.id === draftData.listingDetails.categoryPackageId, selectionInvalid: categoryPackageInvalid, 'motors-listing-details-package-section__disabled': package.isDisabled}">
                  <tg-row class="motors-listing-details-package-section__card__recommended-row">
                    <div *ngIf="package.id === 2" class="motors-listing-details-package-section__card__recommended" [ngClass]="{'disable': package.isDisabled}">
                      Recommended</div>
                  </tg-row>

                  <tg-row>
                    <tg-col>
                      <label class="motors-listing-details-package-section__card__input-container">
                        {{ package.packageUi.heading }}
                        <input #packageInput type="radio" [name]="package.name" [value]="package.id" (change)="onSelectPackage(package.code)"
                          [(ngModel)]="draftData.listingDetails.categoryPackageId"
                          [validation]="validation.listingDetails.categoryPackageId | toValidator" />
                        <span [ngClass]="{'disable': package.isDisabled}" class="checkmark"></span>
                      </label>
                    </tg-col>
                  </tg-row>

                  <tg-row class="motors-listing-details-package-section__card__row-flex-grow">
                    <tg-col>
                      <label class="motors-listing-details-package-section__card__subtitle"
                        [innerHTML]="package.packageUi.subtitle"></label>
                    </tg-col>
                  </tg-row>

                  <tg-row class="motors-listing-details-package-section__card__row-bottom-border">
                    <tg-col sm="12" [lg]="zeroChargeMessage ? 6 : 5">
                      <div *ngIf="package.price" class="motors-listing-details-package-section__card__price"
                        [innerHTML]="package.price | tgCurrency | tmSupCurrency"></div>
                      <div *ngIf="package.price === 0" class="motors-listing-details-package-section__yourPromotion" [ngClass]="zeroChargeMessage | zeroChangeFontSize">{{zeroChargeMessage}}</div>
                    </tg-col>
                    <tg-col sm="12" [lg]="zeroChargeMessage ? 6 : 7" *ngIf="draftData.listingDetails.sellingType === SellingTypeEnum.auction">
                      <label class="motors-listing-details-package-section__card__successFee" [ngClass]="{'disable': package.isDisabled}">+2% Success fee*</label>
                    </tg-col>
                  </tg-row>

                  <tg-row class="motors-listing-details-package-section__card__row-bottom-border">
                    <tg-col md="10" sm="12">
                      <ul tgList2 compact type="icon">
                        <li *ngFor="let detail of package.features" [ngClass]="{ disabled: !detail.checked}">
                          <div [innerHTML]="detail.description"></div>
                          <tg-icon-left *ngIf="detail.checked" name="basic-tick" alt="tick" size="small"></tg-icon-left>
                          <tg-icon-left *ngIf="!detail.checked" name="basic-cross" alt="tick" size="small">
                          </tg-icon-left>
                        </li>
                      </ul>
                    </tg-col>
                  </tg-row>

                  <tg-row>
                    <tg-col class="motors-listing-details-package-section__card__example-col">
                      <a href="javascript:void(0);" class="motors-listing-details-package-section__card__example-link"
                        (click)="openModal(package.id)">
                        <tg-icon-left name="eye" alt="tick" size="small"></tg-icon-left> See an example
                      </a>
                    </tg-col>
                  </tg-row>
                </tg-card>
              </tg-col>
            </tg-row>

            <tg-row *ngIf="draftData.listingDetails.sellingType === SellingTypeEnum.auction">
              <tg-col lg="8" sm="12">
                <div class="motors-listing-details-package-section__successDiv">
                  <label class="motors-listing-details-package-section__successDiv__title">*Success fees</label>
                  <label class="motors-listing-details-package-section__successDiv__text">
                    A success fee of 2% applies to all auctions that close above reserve with a winning bid, Buy Now, or
                    fixed price offer. The maximum success fee is $99
                  </label>
                </div>
              </tg-col>
            </tg-row>

            <tg-row>
              <tg-col>
                <span class="motors-listing-details-package-section__explanationSpan">
                  <sup>1</sup> On average - Trade Me site statistics, April 2022.<br />
                  <sup>2</sup> Except where an auction has already got bids.<br />
                  List for up to 28 days. You can relist for free with a Basic package until sold.
                  Listings must be relisted within 45 days of expiring and will be of the same listing type (i.e. Auction or Asking Price).</span>
              </tg-col>
            </tg-row>
          </tg-col>
        </tg-row>
      </tg-col>
    </tg-row>

    <tg-modal *ngIf="showModal" (close)="closeModal()" fullscreen>
      <tg-modal-header>
        <h2>View example</h2>
      </tg-modal-header>
      <tg-modal-body>
        <tg-toggle [(ngModel)]="selectedPackageName" name="selectedPackage" label="Choose a listing option" required="true" (change)="setSelectedPackage($event)">
          <tg-toggle-item *ngFor="let packageName of packageNameList" [value]="packageName">
            {{ packageName }}
          </tg-toggle-item>
        </tg-toggle>
        <img src="./assets/images/{{ selectedPackage?.photo }}" />
      </tg-modal-body>
      <tg-modal-footer></tg-modal-footer>
    </tg-modal>
  </div>
</form>